import { DateRange } from "./DateRange";

export class SystemInfoQuery {
    title?: string;
    activeOnly: boolean = false;
    startedRange?: DateRange;
    lastStart?: Date;
    lastInstance?: string;
}